var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchInput',{attrs:{"value":_vm.search,"data-test-id":"searchFilesInput","placeholder":_vm.$t('Search Files')},on:{"input":_vm.onChangeInput}})}
var staticRenderFns = []

export { render, staticRenderFns }